import { useEffect, useRef, useCallback } from 'react'

const SESSION_TTL_MS = import.meta.env.VITE_SESSION_TTL_MS
  ? parseInt(import.meta.env.VITE_SESSION_TTL_MS, 10)
  : 15 * 60 * 1000
const WARNING_THRESHOLD_MS = 60 * 1000

export const useSessionTimeout = (onSessionExpiring: () => void) => {
  const expiresAt = useRef(Date.now() + SESSION_TTL_MS)
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null)
  const firedRef = useRef(false)

  const resetTimer = useCallback(() => {
    expiresAt.current = Date.now() + SESSION_TTL_MS
    firedRef.current = false
  }, [])

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      if (firedRef.current) return
      const remaining = expiresAt.current - Date.now()
      if (remaining <= WARNING_THRESHOLD_MS) {
        firedRef.current = true
        onSessionExpiring()
      }
    }, 1000)

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current)
    }
  }, [onSessionExpiring])

  return { resetTimer }
}
